import React from 'react';

import { req, useApiGet } from 'react-reqq-lite';
import Cookie from 'js-cookie';
import { initializeApp } from 'firebase/app';
import 'firebase/database';
import {
  getAuth,
  signInWithCustomToken,
  onAuthStateChanged,
} from 'firebase/auth';
import {
  getMessaging,
  onMessage,
  getToken,
  isSupported,
} from 'firebase/messaging';

import * as c from './constants';

export const FIREBASE_STATUS = {
  0: 'INITIAL',
  1: 'AUTHENTICATING...',
  2: 'CONNECTED',
  3: 'AUTHENTICATION FAILED',
};

export const MESSAGING_ID = process.env.REACT_APP_FIREBASE_MESSAGING_ID;
const CONFIG = process.env.REACT_APP_FIREBASE_CREDENTIAL;

export const initApp = () => {
  try {
    const fbCreds = JSON.parse(atob(CONFIG));

    return initializeApp(fbCreds);
  } catch (err) {
    // eslint-disable-next-line
    console.log(err);
    return null;
  }
};

export const initAuth = async (fb) => {
  let $user = null;

  if (fb) {
    const auth = getAuth(fb);

    const tryAuth = (token) => {
      signInWithCustomToken(auth, token)
        .then((user) => {
          $user = user;
          req.set(c.FIREBASE_USER, user);
          req.set(c.FIREBASE_STATUS, 2);
        })
        .catch((err) => {
          console.log(err); // eslint-disable-line
          req.set(c.FIREBASE_STATUS, 3);
        });
    };

    await onAuthStateChanged(auth, (user) => {
      if (!user) {
        const fbToken = Cookie.get('_fbToken') || '';
        tryAuth(fbToken);
        return;
      }

      $user = user;
      req.set(c.FIREBASE_USER, user);
      req.set(c.FIREBASE_STATUS, 2);
    });
  }

  return $user;
};

export const initMessaging = async (fb) => {
  let tokenResponse = null;

  if (fb) {
    tokenResponse = await isSupported()?.then(async (status) => {
      if (!status) return null;

      const messaging = getMessaging(fb);

      const token = await getToken(messaging)
        .then(($token) => $token)
        .catch((err) => {
          // eslint-disable-next-line
          console.log(err);
        });

      return token;
    });
  }

  return tokenResponse;
};

export const useBroadcastMessage = (id) => {
  React.useEffect(() => {
    let callback = () => {};
    let broadcast = null;

    try {
      broadcast = new BroadcastChannel(id);
      callback = (e) => req.set(c.FIREBASE_LISTENER, e?.data);
      broadcast.addEventListener('message', callback);
    } catch (err) {
      // eslint-disable-next-line
      console.log(err);
    }

    return () => broadcast.removeEventListener('message', callback);
  }, [id]);
};

export const useInitListener = () => {
  const fb = initApp();
  useBroadcastMessage('notifications');
  React.useEffect(() => {
    if (!fb) return;
    isSupported()?.then((status) => {
      if (!status) return;
      const listener = getMessaging(fb);
      onMessage(listener, (res) => {
        req.set(c.FIREBASE_LISTENER, res);
      });
    });
  }, [fb]);
};

export const useGetListener = () => {
  const data = useApiGet(c.FIREBASE_LISTENER, null);

  return data;
};
